import PropTypes from 'prop-types';
import { useState, useCallback, useMemo } from 'react';
// mui
import { DataGrid } from '@mui/x-data-grid';
// component
import CustomGridToolbar from '../../../components/custom-gridtoolbar';
import Scrollbar from '../../../components/scrollbar';
import { newFDate } from '../../../utils/formatTime';
// ---------------------------------------------------------------------------------------------------------------

RatingReportGrid.propTypes = {
    columnData: PropTypes.array,
    rowData: PropTypes.array,
    loading: PropTypes.bool,
    lastDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
};
// ---------------------------------------------------------------------------------------------------------

export default function RatingReportGrid({ columnData, rowData, loading, lastDate }) {

    const columns = useMemo(() => [
        ...columnData,
        {
            field: 'rating',
            headerName: 'Rating',
            width: 100,
        },
    ], [columnData]);

    const [pageSize, setPageSize] = useState(100);

    const CustomToolbar = useCallback(() =>
        <CustomGridToolbar
            rows={rowData}
            records={` Total No. of Records [${rowData.length}]`}
            lastUpdate={newFDate(lastDate)}
            columnData={columns}
        />, [rowData, lastDate, columns]);

    return (
        <Scrollbar>
            <DataGrid
                rows={rowData}
                columns={columns.filter(column => column.field !== 'id')}
                getRowId={(row) => rowData.indexOf(row)}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[100, 150, 200]}
                components={{
                    Toolbar: CustomToolbar,
                }}
                sx={{ height: 325 }}
                density='compact'
                loading={loading}
            />
        </Scrollbar>
    );
}